import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { httpOptions, serviceConstants, formOptions } from '../../constants/service.constants';
import { Observable } from 'rxjs';
import { ScreenResponseModel } from 'src/app/models/common';

@Injectable({
  providedIn: 'root'
})
export class EapSummaryService {

  constructor(private http: HttpClient) { }

  ///////////// //////////////////////
  DeleteRecord(Url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions);
  }
  getGeneralInformation(Url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions);
  }
  SaveEAPGeneralInfo(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, formOptions);
  }

  getApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getEAPSearchSummary(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, httpOptions);
  }

  getRegistSummary(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  resendUserEmail(ID: string, OrgId: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/resenduseremail/' + ID + '/' + OrgId, httpOptions);
  }

  GetregistrationProgram(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  getEAPApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getSummaryData(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  fetchSearchData(url: any, body: any) {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }
  Insert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }
  FilesInsert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, formOptions);
  }
  masterData(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  getScreenDataForEdit(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  UpdateStatus(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  updateUser(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }

  SaveStudyTeamOrg(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, formOptions);
  }

  SaveStudyTeam(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, formOptions);
  }

  SaveIRB(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, formOptions);
  }

  getEAPScreenResponse(model: ScreenResponseModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screenresponse/getscreenresponse", model, httpOptions);
  }
}
